import { useMutation } from '@tanstack/react-query'
import { workflowRunFilesApi } from '@/api/workflowRunFiles'

export function useUploadWorkflowRunFiles(projectId: string) {
  return useMutation({
    mutationFn: (files: File[]) => workflowRunFilesApi.upload(projectId, files),
  })
}

export function useDeleteWorkflowRunFile(projectId: string) {
  return useMutation({
    mutationFn: (blobPath: string) => workflowRunFilesApi.delete(projectId, blobPath),
  })
}
